import React, { useState } from 'react';
import { EVENT_STATUS, ACTIVE_HOMESCREEN } from '../../enums';
import { connect } from 'react-redux';
import { isSaaSAdmin } from '@/redux/util';
import { thunkCreateEvent, assertSocketConnected } from '@/redux/actions';
import {
	displayMessage,
	displayCreateEventError,
} from 'components/WebsocketSubscriptions/wsHelpers';
import { defaultWidgets } from '../Widgets';
import {
	defaultThemeSaaSJSON,
	defaultThemeJSON,
} from 'routes/EventDetail/routes/Theme/defaultTheme';
import { DEFAULT_ROUTES_STR } from 'routes/EventDetail/routes/Navigation/Routes';

import EventCreate from './EventCreate';

const EventCreateContainer = props => {
	const {
		onCreate,
		onSubmitStart,
		onCreateFailed,
		currentClientID,
		createEvent,
		assertConnected,
	} = props;
	const [submitting, setSubmitting] = useState(false);

	const onFinish = async values => {
		const { name, status, location, image_url } = values;
		const date = new Date();
		const eventInput = {
			name,
			location,
			event_image_url: image_url,
			timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/New_York',
			start_time: new Date().toISOString(),
			end_time: new Date(date.setMonth(date.getMonth() + 1)).toISOString(),
			status: status ? EVENT_STATUS.ACTIVE : EVENT_STATUS.INACTIVE,
			client_id: currentClientID,
			active_homescreen: isSaaSAdmin() ? ACTIVE_HOMESCREEN.WIDGET : ACTIVE_HOMESCREEN.STANDARD,
			theme: isSaaSAdmin() ? defaultThemeSaaSJSON : defaultThemeJSON,
			side_navigation: DEFAULT_ROUTES_STR,
		};
		setSubmitting(true);
		let event;
		try {
			assertConnected();
			await onSubmitStart?.();
			event = await createEvent(eventInput, defaultWidgets);
		} catch (error) {
			displayCreateEventError(error);
			if (onCreateFailed) onCreateFailed(error);
			return;
		} finally {
			setSubmitting(false);
		}
		displayMessage('Event created');
		onCreate(event);
	};

	return <EventCreate {...props} onFinish={onFinish} submitting={submitting} />;
};

const msp = ({ clients }) => ({
	currentClientID: clients.currentClient.id,
});

const mdp = dispatch => ({
	createEvent: (eventInput, widgets) => dispatch(thunkCreateEvent(eventInput, widgets)),
	assertConnected: () => dispatch(assertSocketConnected()),
});

export default connect(msp, mdp)(EventCreateContainer);
